export default __webpack_public_path__ + "static/media/pianowebBack.08e3b56a.jpg";